import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Tooltip, Form, Input, Button } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import AdminDataTable from "../../Layouts/partials/data-table";
import { RolesContext } from "../../context/RolesContext";
import { ConfirmationModal } from "../../components/Modals/index";
import { GenericContext } from "../../context/genericContext";
import { Link } from "react-router-dom";
import {
  CREATE_ROLES_ROUTE,
  UPDATE_ROLES_ROUTE,
  ROLES_DETAIL_ROUTE,
  PERMISSIONS,
} from "../../constants";
import { getFormattedDateTime } from "../../utils";
import FilterDrawer from "../../components/filterDrawer";
import { ScaleLoader } from "react-spinners";
import moment from "moment";
function RoleManagement() {
  const { rolesList, getRolesList, deleteRole } = useContext(RolesContext);
  const { getUserPermission, userPermissions } = useContext(GenericContext);
  const CreateAccess = PERMISSIONS.find((x) => x.route === CREATE_ROLES_ROUTE);
  const UpdateAccess = PERMISSIONS.find(
    (x) => x.route === UPDATE_ROLES_ROUTE.replace("/:id", "")
  );
  const [selectedData, setSelectedData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [page, setPage] = useState(1);
  const { meta, data } = rolesList;
  const paginationConfig = {
    pageSize: meta?.per_page,
    total: meta?.total,
  };

  const [form] = Form.useForm();
  const handleFormFinish = () => {
    const credentials = form.getFieldsValue();
    setFilteredData(credentials);
    setLoading(true);
  };

  useEffect(() => {
    let filterQuery = "";
    if (filteredData) {
      Object.keys(filteredData).forEach(function (key) {
        if (filteredData[key]) {
          filterQuery += `&${key}=${filteredData[key]}`;
        }
      });
    }
    getUserPermission();
    getRolesList(page, true, filterQuery, () => {
      setLoading(false);
      setFilterOpen(false);
    });
  }, [page, filteredData]);

  const handleResetForm = () => {
    form.resetFields();
    setFilteredData(null);
    form.setFieldsValue({
      name: undefined,
    });
    setFilterOpen(false);
  };
  const drawerSec = () => (
    <Form
      form={form}
      className="form"
      initialValues={filteredData}
      onFinish={handleFormFinish}
    >
      <label className="form-lbl">Name:</label>
      <Form.Item name={"name"}>
        <Input
          name="name"
          placeholder="Filter by role name"
          className="form-input"
        />
      </Form.Item>
      <Form.Item>
        <Button
          htmlType="submit"
          disabled={isLoading}
          className="form-btn"
          style={{ minWidth: "100%" }}
        >
          {isLoading ? (
            <ScaleLoader
              color={"#FFF"}
              loading={isLoading}
              height={14}
              width={2}
            />
          ) : (
            "Apply Filters"
          )}
        </Button>
        <span className="form-rm-btn" onClick={handleResetForm}>
          Reset Filters
        </span>
      </Form.Item>
    </Form>
  );

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "1",
      render: (data, value, i) => (
        <b>{(page == 1 ? 0 : (page - 1) * 10) + (i + 1)}</b>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "2",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (data, value) => {
        return <span>{data}</span>;
      },
    },
    {
      title: "Created By",
      dataIndex: "creator",
      key: "3",
      sorter: (a, b) => a.creator?.email.localeCompare(a.creator?.email),
      render: (data, value) => {
        return <span>{data.email}</span>;
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "4",
      sorter: (a, b) =>
        moment(a.created_at).unix() - moment(b.created_at).unix(),
      render: (data, value) => {
        return <span>{getFormattedDateTime(data)}</span>;
      },
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "5",
      sorter: (a, b) =>
        moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      render: (data, value) => {
        return <span>{getFormattedDateTime(data)}</span>;
      },
    },

    {
      title: "Action",
      key: "6",
      render: (data, record) => {
        return (
          <div className="actions">
            <Link
              to={ROLES_DETAIL_ROUTE.replace(":dataid", data.id)}
              className="update"
            >
              <Tooltip title="Role Detail">
                <EyeOutlined />
              </Tooltip>
            </Link>
            {userPermissions.includes(UpdateAccess.access) && (
              <Link
                to={UPDATE_ROLES_ROUTE.replace(":id", data.id)}
                className="update"
              >
                <Tooltip title="Update Role">
                  <EditOutlined />
                </Tooltip>
              </Link>
            )}
            {/* <span style={{ opacity: data.is_default ? 0.3 : 1 }}>
              {data.is_default ? (
                <DeleteOutlined style={{ cursor: "auto" }} />
              ) : (
                <Tooltip title="Delete Role">
                  <DeleteOutlined onClick={() => handleConfirmModal(record)} />
                </Tooltip>
              )}
            </span> */}
          </div>
        );
      },
    },
  ];

  //HANDLERS

  const handleConfirmModal = (role) => {
    setSelectedData(role);
    setShowConfirmationModal(true);
  };
  const handleConfirmationModalClose = () => {
    setShowConfirmationModal(false);
  };

  const handleDeleteRole = (id) => {
    deleteRole(id);
  };

  const handlePageChange = (page, pageSize) => {
    setPage(page);
  };

  const filterHandler = () => {
    setFilterOpen(!isFilterOpen);
  };

  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            {userPermissions.includes(CreateAccess.access) && (
              <div className="add-btn">
                <Link to={CREATE_ROLES_ROUTE}>Create Role</Link>
              </div>
            )}
            <AdminDataTable
              title="Roles"
              filterHandler={filterHandler}
              data={data}
              columns={columns}
              pagination={{ ...paginationConfig, onChange: handlePageChange }}
            />
          </Col>
        </Row>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          handleClose={handleConfirmationModalClose}
          title={"Delete Role?"}
          description={"Are you sure you want to delete this role?"}
          deleteHandler={handleDeleteRole}
          selectedData={selectedData}
        />
      )}
      <FilterDrawer
        visible={isFilterOpen}
        toggle={filterHandler}
        content={drawerSec()}
      />
    </>
  );
}

export default RoleManagement;
